export const favoriteFilterKeys = {
  productIds: 'favAdmASRProductIds',
  platformIds: 'favAdmASRPlatformIds',
  managerIds: 'favAdmASRManagerIds',
  affiliateIds: 'favAdmSRAffiliateIds',
  trackerIds: 'favAdmASRTrackerIds',
  creativeIds: 'favAdmASRCreativeIds',
  brands: 'favAdmASRBrands',
  currencies: 'favAdmASRCurrencies',
  dealTypes: 'favAdmASRDealTypes',
  registrationDates: 'favAdmASRRegDates',
  firstDepositDates: 'favAdmASRFirstDepDates',
  anid: 'favAdmASRAnid',
  playerId: 'favAdmASRPlayerId',
  source1: 'favAdmASRSource1',
  source2: 'favAdmASRSource2',
  source3: 'favAdmASRSource3',
  source4: 'favAdmASRSource4',
  source5: 'favAdmASRSource5',
  deviceTypes: 'favAdmASRDeviceTypes',
  geo: 'favAdmASRGeo',
}

export const reportStorageProps = {
  type: 'agent-statistics-report',
  target: 'filters',
  tableSettingsTarget: 'table-settings',
  savedReportTarget: 'agent-statistics-report-settings',
  savedReportFavoritesTarget: 'agent-statistics-report-favorites',
  savedReportDefaultTarget: 'agent-statistics-report-default',
  exceptions: ['group_by', 'period', 'sent_from', 'sent_to'],
  exceptionsIds: ['productIds', 'platformIds', 'managerIds', 'affiliateIds', 'trackerIds', 'brands', 'currencies', 'dealTypes', 'deviceTypes'],
  exceptionsStr: ['anid', 'playerId', 'source1', 'source2', 'source3', 'source4', 'source5'],
  maxFavoriteReports: 10,
}
